import React, {useState} from 'react';
import {ReceiverVariant} from "../ChatApp";

function ChatSelection({onSelect, toggleChat}) {
    const [subscription] = useState(true);

    return (
        <>
            <div className="chat-app__head">
                <h2>Чаты</h2>
                <button onClick={toggleChat}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.75684 14.3145C3.51758 14.082 3.52441 13.6855 3.75684 13.4531L8.13184 9.07129L3.75684 4.69629C3.52441 4.46387 3.52441 4.07422 3.75684 3.83496C3.98926 3.58887 4.39258 3.5957 4.625 3.83496L9 8.20996L13.375 3.83496C13.6074 3.5957 14.0039 3.5957 14.2432 3.83496C14.4824 4.06738 14.4756 4.46387 14.2432 4.69629L9.86816 9.07129L14.2432 13.4531C14.4756 13.6855 14.4756 14.0752 14.2432 14.3145C14.0107 14.5537 13.6074 14.5469 13.375 14.3145L9 9.93945L4.625 14.3145C4.39258 14.5469 3.99609 14.5469 3.75684 14.3145Z"
                            fill="#707991"/>
                    </svg>
                </button>
            </div>
            <ul className="chat-selection">
                <li onClick={() => onSelect(ReceiverVariant.Boost)}>
                    <div className="chat-avatar chat-avatar__online">
                        <img className="chat-avatar__img" src="/images/chat/boost.png" alt='Boost'/>
                    </div>
                    <div className="chat-info">
                        <h3>Boost</h3>
                        <p>Отвечаю моментально</p>
                    </div>
                </li>
                {subscription && (
                    <li onClick={() => onSelect(ReceiverVariant.Expert)}>
                        <div className="chat-avatar">
                            <img
                                className="chat-avatar__img"
                                src="/images/chat/expert.png"
                                alt="Эксперт ЕГЭ"
                            />
                        </div>
                        <div className="chat-info">
                            <h3>Эксперт ЕГЭ</h3>
                            <p>Отвечаю в течение 5 минут</p>
                        </div>
                    </li>
                )}
            </ul>
        </>
    );
}

export default ChatSelection;
